import { useState } from "react";
import { ErrorResponse } from "../../../custom-fetch";
import ErrorsAlert from "../../ErrorsAlert/ErrorsAlert";
import Button, { EButtonColor } from "../../ui/Button/Button";
import { EInputType, IInputField } from "../../ui/Input/Input";
import { useInputs } from "../../ui/Input/useInputs";
import ModalBody from "../../ui/Modal/ModalBody/ModalBody";
import ModalFooter from "../../ui/Modal/ModalFooter/ModalFooter";
import IReservation from "../../../shared/IReservation";

enum EInputs {
  reasonToCancel = "reasonToCancel"
}

interface IProps {
  onAccept: (data: IReservation) => Promise<ErrorResponse | null>;
  onCancel: () => void;
  data: IReservation;
}

const ReservationCancelModal: React.FC<IProps> = ({
  onAccept,
  onCancel,
  data,
}) => {
  const { createInput, submit } = useCancelInputs(data);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ErrorResponse | null>(null);

  const submitHandler = async () => {
    setError(null);
    const formData = await submit();
    if (formData) {
      setLoading(true);
      const error = await onAccept({ ...data, ...(formData as any) });
      if (error) setError(error);
      setLoading(false);
    }
  };

  return (
    <>
      <ModalBody style={{ display: "flex", gap: "1rem", flexDirection: "column" }}>
        {createInput(EInputs.reasonToCancel)}
        {error && <ErrorsAlert errors={error.messages} style={{ margin: "0" }} />}
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={submitHandler}
          style={{ marginRight: "0.5rem" }}
          loading={loading}
          color={EButtonColor.DANGER}
        >
          Confirm
        </Button>
        <Button onClick={onCancel}>
          Back
        </Button>
      </ModalFooter>
    </>
  );
};

const useCancelInputs = (data?: IReservation) => {
  const [inputs, setInputs] = useState<IInputField>({
    [EInputs.reasonToCancel]: {
      type: EInputType.reactSelect,
      label: "Reason to cancel",
      value: "",
      placeholder: "",
      options: [
        { label: "Illness", value: "Illness" },
        { label: "Change of plans", value: "Change of plans" },
        { label: "Flight cancelled", value: "Flight cancelled" },
        { label: "Death in family", value: "Death in family" },
        { label: "Other destination preferred", value: "Other destination preferred" },
        { label: "Other provider preferred", value: "Other provider preferred" },
        { label: "Wrong dates booked", value: "Wrong dates booked" },
        { label: "Wrong vehicle category booked", value: "Wrong vehicle category booked" },
        { label: "Wrong destination booked", value: "Wrong destination booked" },
        { label: "Quote booking", value: "Quote booking" },
        { label: "Test booking", value: "Test booking" },
        { label: "Other", value: "Other" },
        { label: "Booking is too expensive", value: "Booking is too expensive" },
      ],
      validation: {
        required: true,
      },
      menuPosition: "fixed",
    },
  });

  const { createInput, submit } = useInputs({ data, inputs, setInputs });

  return { createInput, submit };
};

export default ReservationCancelModal;
